export default __webpack_public_path__ + "static/media/forestly-expl-nn-03b_EN.bf2ba9c3.png";